import { render, staticRenderFns } from "./InvoiceDetailsView.vue?vue&type=template&id=264f0dcc&scoped=true&"
import script from "./InvoiceDetailsView.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetailsView.vue?vue&type=style&index=0&id=264f0dcc&prod&lang=scss&"
import style1 from "./InvoiceDetailsView.vue?vue&type=style&index=1&id=264f0dcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264f0dcc",
  null
  
)

export default component.exports